"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PusherClient = void 0;
const with_encryption_1 = __importDefault(require("pusher-js/with-encryption"));
const axios_1 = __importDefault(require("axios"));
class PusherClient {
    constructor(baseUrl = process.env.VUE_APP_INTERNAL_API_BASE_URL) {
        if (!baseUrl) {
            throw new Error('No base url supplied');
        }
        this.baseUrl = `${baseUrl}/pusher`;
    }
    async connect(token) {
        const config = this.getRequestConfig(token);
        const url = `${this.baseUrl}/settings`;
        const { data } = await axios_1.default.get(url, config);
        const { appKey, token: pusherToken, options: { authEndpoint, cluster }, } = data;
        this.pusher = new with_encryption_1.default(appKey, {
            authEndpoint,
            auth: {
                headers: { authorization: `Bearer ${pusherToken}` },
            },
            cluster,
        });
    }
    async subscribe(token, type, identifier) {
        const payload = {
            type,
            identifier,
        };
        const config = this.getRequestConfig(token);
        const url = `${this.baseUrl}/channels`;
        const { data } = await axios_1.default.post(url, payload, config);
        const { name } = data;
        return this.pusher.subscribe(name);
    }
    listen(channel, event, handler) {
        channel.bind(event, handler);
    }
    connectionListen(state, handler) {
        this.pusher.connection.bind(state, handler);
    }
    unsubscribe(channel) {
        this.pusher.unsubscribe(channel.name);
    }
    unbind(channel, event, handler) {
        channel.unbind(event, handler);
    }
    getRequestConfig(token) {
        return {
            headers: {
                authorization: `Bearer ${token}`,
            },
        };
    }
}
exports.PusherClient = PusherClient;
